export const DeviceOrderItemChildColumns = [
  {
    title: "License Item",
    dataIndex: "LicenseItem",
    key: "LicenseItem",
    width: 150,
  },
  {
    title: "Old License",
    dataIndex: "OldCode",
    key: "OldCode",
    width: 150,
  },
  {
    title: "New License",
    dataIndex: "NewCode",
    key: "NewCode",
    width: 150,
  },
  {
    title: "Free",
    dataIndex: "Free",
    key: "Free",
    width: 80,
    render: (value) =>
      value === 1 || value === "Yes" || value === true
        ? "Yes"
        : value === 0 || value === "No" || value === false
          ? "No"
          : value ?? "",
  },
  {
    title: "",
    dataIndex: "",
    key: "",
    width: 1,
  },
];

export const DeviceOrderItemColumns = () => {
  return [
    {
      title: "Order Time",
      dataIndex: "OrderTime",
      key: "OrderTime",
      render: (text) => (
        <div>
          {typeof text === "string" && text.length >= 16
            ? text.slice(0, 16)
            : ""}
        </div>
      ),
      onHeaderCell: () => ({ onClick: () => {} }),
    },
    {
      title: "Order Type",
      dataIndex: "OrderType",
      key: "OrderType",
      onHeaderCell: () => ({ onClick: () => {} }),
    },
    {
      title: "License Type",
      dataIndex: "LicenseType",
      key: "LicenseType",
      onHeaderCell: () => ({ onClick: () => {} }),
    },
    {
      title: "",
      dataIndex: "",
      key: "",
    },
  ];
};
